import { render, staticRenderFns } from "./FooTable.vue?vue&type=template&id=5dfd318a&scoped=true"
import script from "./FooTable.vue?vue&type=script&lang=js"
export * from "./FooTable.vue?vue&type=script&lang=js"
import style0 from "./FooTable.vue?vue&type=style&index=0&id=5dfd318a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfd318a",
  null
  
)

export default component.exports